import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoConfiguracao } from './indicacao.types';

export const putIndicacaoConfiguracao = async (payload: IndicacaoConfiguracao) => {
	try {
		const response = await BaseClient.put<IndicacaoApiResponse<IndicacaoConfiguracao>>(
			'v2/Indicacao/Configuracao',
			payload
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoConfiguracao>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
